
<template>
    <div>
        stub for editing a quote
    </div>
</template>

<script>
    import Vue from 'vue';
    import { BootstrapVue } from 'bootstrap-vue'
    import axios from 'axios';

    import ErrorsMixin from '../mixins/ErrorsMixin';

    Vue.use(BootstrapVue)

    export default {
        name: 'QuoteEdit',
        mixins: [ErrorsMixin],
        props: {
            apiControllerUrl: {
                type: String,
                required: true
            },
            quoteId: {
                type: Number,
                default: 0
            },
            label: {
                type: String,
                default: 'Quote'
            }

        },
        data: function () {
            return {

                quote: null,
            }
        },
        computed: {
            // empty
        },

        methods: {
            loadQuote: function () {
                axios
                    .get(this.apiControllerUrl + this.quoteId)
                    .then(response => {
                        this.quote = response.data;
                        //console.log(this.availability);
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },

            saveAvailability: function () {
                axios
                    .post(this.apiControllerUrl + this.quoteId, JSON.stringify(this.quote),
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                    .then(() => {
                        this.$bvToast.toast('Availability Template saved successfully', {
                            title: 'Availability Template Saved',
                            variant: 'success',
                            appendToast: true
                        });
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            }
        },
        mounted: function () {
            this.loadQuote();
        }
    }
</script>
